import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-static';
import em from 'polished/lib/helpers/em';
import { ACTIVE_YEAR, FESTIVAL_DAYS } from '@flow/utils/constants';

const Logo = styled.span` 
  font-family: Flow-Poster-Bold !important;  
  font-size: 3.7em;

  .ss01 {
    font-feature-settings: "ss01" 1;
  }
  
  a {
    * {
      font-family: Flow-Poster-Bold !important;
    }
  
    display: inline-block;
    transition: color .2s ease-out;
    
    &:${props => props.theme.hoverProperty} {
      color: ${props => props.highlightColor ? props.highlightColor : props.theme.highlightColor};
    }
  }
  
  .logo {
    .label {
      position: relative;
      margin-right: ${em(0.7, 3.7)};
      &:after {
        content: '®';
        font-size: ${em(1.3, 3.7)};
        position: absolute;
        top: ${em(0.6, 1.3)};
        right: ${em(-1, 1.3)};
      }
    }
  }

  @media (max-width: 1570px) {
    font-size: 2.7em;
  }
  
  @media (max-width: 1180px) {
    .city-name {
      display: none;
    }
  }
  
  @media (max-width: 1020px) {
    .logo .dingbats {
      display: none;
    }
  }
  
  @media (max-width: 670px) {
    time .year {
      display: none;
    }
  }
  
  @media (max-width: 550px) {
    time {
      font-size: ${em(2.1, 3.7)};
    }
  }
  
  @media (max-width: 490px) {
    font-size: ${37 / (490 * 0.01)}vw;
  }
  
  @media (max-width: 410px) {
    time {
      display: block;
    }
  }
  
  @media (max-width: 360px) {
    font-size: 2.7em;
  }
  
  /*@media (max-width: 470px) {
    font-size: ${37/(470*0.01)}vw;
  }*/
`;

interface Props {
  appLanguage: IAppLanguage;
  highlightColor?: string;
}

export const FlowLogo = ({
  highlightColor,
  appLanguage
}: Props) => {
  if (appLanguage) {
    return (
      <Logo highlightColor={highlightColor}>
        <Link to={appLanguage.path}>
          <span className="logo"><span className="label logo-type">F<span className="ss01 logo-type">L</span><span className="ss01 logo-type">O</span>W F<span className="ss01 logo-type">E</span>STIV<span className="ss01 logo-type">A</span>L</span> <span className="dingbats">❢</span></span> <span className='city-name logo-type'>H<span className="ss01 logo-type">E</span><span className="ss01 logo-type">L</span>SINKI <span className="dingbats">✸</span></span> <time>{FESTIVAL_DAYS}<span className='year logo-type'>{ACTIVE_YEAR}</span></time>
        </Link>
      </Logo>
    )
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/logo/FlowLogo.tsx